import { RSAA } from 'redux-api-middleware'; // RSAA = '@@redux-api-middleware/RSAA'

const opts = { //base options for api request
  headers: { 'Content-Type': 'application/json' },
  credentials: 'same-origin',
  types: ['REQUEST', 'SUCCESS', 'FAILURE']
}


export const fetchSession = () => ({
  [RSAA]: {
    ...opts,
    endpoint: API_BASE + 'session',
    method: 'GET',
  }
})

export const fetchVacancies = () => ({
  [RSAA]: {
    ...opts,
    endpoint: API_BASE + 'vacancies',
    method: 'GET',
  }
})

export const fetchCandidates = () => ({
  [RSAA]: {
    ...opts,
    endpoint: API_BASE + 'candidates',
    method: 'GET',
  }
})

export const fetchRecruiters = () => ({
  [RSAA]: {
    ...opts,
    endpoint: API_BASE + 'recruiters?populate=company',
    method: 'GET',
  }
})

export const fetchUsers = () => ({
  [RSAA]: {
    ...opts,
    endpoint: API_BASE + 'users',
    method: 'GET',
  }
})


export const updateUser = (id,query) => ({
  [RSAA]: {
    ...opts,
    endpoint: API_BASE + `users/${id}`,
    body: JSON.stringify(query),
    method: 'PATCH',
  }
})


/* not yet in use */
export const fetchMatches = () => ({
  [RSAA]: {
    ...opts,
    endpoint: API_BASE + 'matches',
    method: 'GET',
  }
})

export const updateMatch = (id,query) => ({
  [RSAA]: {
    ...opts,
    endpoint: API_BASE + `matches/${id}`,
    body: JSON.stringify(query),
    method: 'PATCH',
  }
})

export const uploadResume = (resume,candidateId,resumeID,resumeName) => ({
  [RSAA]: {
    headers: { 'Content-Type': 'application/pdf' },
    redentials: 'same-origin',
    types: ['REQUEST', 'SUCCESS', 'FAILURE'],
    endpoint: API_BASE + `matches/${id}`,
    body: resume,
    method: 'PATCH',
  }
})



// WEBPACK FOOTER //
// ./src/actions/api.js